//Import required modules
import React from 'react';
import * as d3 from 'd3';
import PropTypes from 'prop-types'

//Import Data
const pieData = d3.range(1,1000)

const Pie = (props, {store}) =>
{
let vizData = store.getState().userPalette.flat()
let userWindow = store.getState().userWindow;
let circleCount = userWindow.circleCount
let theme = store.getState().theme
let darkColor = userWindow.darkColor
let lightColor = userWindow.lightColor
let width = userWindow.vizHolderWidth

let height = (vizData.length>circleCount?202:270),
    margin = 5,
    innerRadius = 50;
let radius = Math.min(width, height) / 2 - margin
let pieDataSub = pieData.slice(0,vizData.length)
let strokeColor = theme === 'dark'?lightColor:darkColor;
let strokeWidth = '2px'
let cornerRadius = 5;


// Compute the position of each group on the pie:
let pie = d3.pie()
            .value((d) => d.value)
let data_ready = pie(d3.entries(pieDataSub))
let arc = d3.arc()
            .innerRadius(innerRadius)         // This is the size of the donut hole
            .outerRadius(radius)
            .cornerRadius(cornerRadius)

return (
    <svg width={width}
         height={height}
         id='myVizPIE'>
             <g transform={`translate(${width/2},${height/2})`}>
                 {data_ready.map((d,i) => 
                    <path key={i}
                          d={arc(d,d.index)}
                          fill={vizData[i].color}
                          stroke={strokeColor}
                          strokeWidth={strokeWidth}>
                    </path>)
                 }
             </g>
    </svg>
)
}


Pie.contextTypes = {
    store: PropTypes.object
}

export default Pie;